import { ReactNode, useState } from "react";
import { ClickAwayListener, Tooltip, TooltipProps } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

type Props = {
  label: ReactNode;
  title: NonNullable<ReactNode>;
  placement?: TooltipProps["placement"];
};

const useStyles = makeStyles((theme) => ({
  trigger: {
    color: theme.palette.primary.main,
    cursor: "pointer",
    fontSize: "0.8125rem",
    background: "none",
    border: 0,
    padding: 0,
    fontFamily: "inherit",
    textDecoration: "underline"
  },
  tooltip: {
    backgroundColor: "#FFFFFF",
    color: "#495459",
    borderRadius: 8,
    boxShadow: "0 8px 24px rgba(14, 46, 58, 0.18)",
    fontSize: "1rem",
    lineHeight: "1.5rem",
    padding: theme.spacing(1.5)
  },
  arrow: {
    color: "#FFFFFF"
  },
  tooltipPlacementTop: {
    margin: "4px 0"
  },
  tooltipPlacementBottom: {
    margin: "10px 0"
  }
}));

const ClickableTooltip = ({ label, title, placement = "bottom" }: Props) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <div style={{ display: "inline-block" }}>
        <Tooltip
          arrow
          open={open}
          placement={placement}
          onClose={() => setOpen(false)}
          title={title}
          classes={{
            tooltip: classes.tooltip,
            arrow: classes.arrow,
            tooltipPlacementTop: classes.tooltipPlacementTop,
            tooltipPlacementBottom: classes.tooltipPlacementBottom
          }}
          disableFocusListener
          disableHoverListener
          disableTouchListener
        >
          <button
            type="button"
            className={classes.trigger}
            onClick={() => setOpen((prev) => !prev)}
          >
            {label}
          </button>
        </Tooltip>
      </div>
    </ClickAwayListener>
  );
};

export default ClickableTooltip;
